import { EntityType, getDefaultAddressSchemeTypeByCountry } from '@components'

import { useCallback } from 'react'

import { CustomerAddress } from '../../../types/customerForm'
import { useCustomerForm } from '../contexts/customerFormContext'

export const useUpdateDependentCustomerFormValues = () => {
  const { customerForm } = useCustomerForm()
  const { setValue, getValues } = customerForm

  const handleAddressSync = useCallback(
    (referenceAddress?: CustomerAddress) => {
      if (!referenceAddress) {
        setValue('shippingAddress', undefined)
        return
      }

      setValue('shippingAddress.streetAddress1', referenceAddress?.streetAddress1)
      setValue('shippingAddress.streetAddress2', referenceAddress?.streetAddress2)
      setValue('shippingAddress.pobox', referenceAddress?.pobox)
      setValue('shippingAddress.city', referenceAddress?.city)
      setValue('shippingAddress.country', referenceAddress?.country)
    },
    [setValue],
  )

  const handleVATNumberSync = useCallback(
    (vatNumber?: string) => {
      setValue('vatNumber', vatNumber)
      setValue('eInvoiceAddress.address', vatNumber)
    },
    [setValue],
  )

  const handleAddressCountryChange = useCallback(
    (countryId?: string) => {
      if (countryId) {
        setValue('entityType', EntityType.Private)
        const isPublicEntity = false
        const defaultEInvoiceScheme = getDefaultAddressSchemeTypeByCountry(isPublicEntity, countryId)
        setValue('eInvoiceAddress.scheme', defaultEInvoiceScheme)
        if (countryId === 'FR') {
          setValue('eInvoiceAddress.address', '')
        } else {
          const vatNumber = getValues('vatNumber')
          setValue('eInvoiceAddress.address', vatNumber)
        }
        const autoCompletedFields = getValues('autoCompletedFields')
        setValue('autoCompletedFields', { ...autoCompletedFields, 'eInvoiceAddress.address': false })
      }
    },
    [setValue, getValues],
  )

  return {
    handleAddressCountryChange,
    handleAddressSync,
    handleVATNumberSync,
  }
}
